// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 195 ? "bf5f3635" : chunkId) + "." + {"123":"9f23e67c366e75e5","195":"bddb1460769bf98e","257":"0fbc3bc440cad3c3"}[chunkId] + ".js";
};